// src/components/login/basic/EasyTab.js
import React, {useState} from 'react';
import GoogleLogic from 'components/login/GoogleLogic';

const SignInputEasy = ({text, detailText, showDetails, handleClick}) => {
    const [hovered, setHovered] = useState(false);

    const onMouseEnter = () => {
        setHovered(true);
    };

    const onMouseLeave = () => {
        setHovered(false);
    };

    const localHandleClick = () => {
        handleClick();
    };

    return (
        <div className="sign-input-easy">
            {!showDetails ?
                <p
                    className={`sign-input-easy-text basic ${hovered ? 'hovered' : ''}`}
                    onClick={localHandleClick}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                >
                    {text}
                </p>
                :
                <div>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <p
                            className={`sign-input-easy-text basic hovered`}
                            onClick={localHandleClick}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                        >
                            {text}
                        </p>
                    </div>
                    <p
                        className="sign-input-easy-text detailed"
                        onClick={localHandleClick}
                    >
                        {detailText}
                    </p>
                </div>
            }
        </div>
    );
};

const EasyTab = ({onMissingUserName}) => {
    const [activeDetail, setActiveDetail] = useState(null);

    const handleDetailClick = (index) => {
        setActiveDetail(activeDetail === index ? null : index);
    };

    return (
        <div>
            <div className="google-button-highlight">
                <GoogleLogic isBlue={true} onMissingUserName={onMissingUserName}/>
            </div>
            <SignInputEasy
                text="Instant access"
                detailText="Your mail is trustworthy even without waiting for verification message."
                showDetails={activeDetail === 2}
                handleClick={() => handleDetailClick(2)}
            />
            <SignInputEasy
                text="Three clicks to register"
                detailText="Sign up in seconds without typing passwords or codes."
                showDetails={activeDetail === 0}
                handleClick={() => handleDetailClick(0)}
            />
            <SignInputEasy
                text="Only email is saved"
                detailText="We only store your email. Anything else from Google is ignored."
                showDetails={activeDetail === 1}
                handleClick={() => handleDetailClick(1)}
            />
        </div>
    );
};

export default EasyTab;